import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location, formatDate } from '@angular/common';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { MerchantService,MerchantFilter } from '../../../views/pages/merchants/merchant-master/merchant.service';
import { Router } from '@angular/router';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { StorageService } from 'src/app/_services/storage.service';
import { ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridApi, GridReadyEvent, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { environment } from 'src/environments/environment';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TransactionMasterService } from '../../pages/fraud-prevention/transaction-master-rule/transaction-master-service';
import { CustomerService } from '../customers/customer-service';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

export interface merchantFilter {
  "columns"?: any;
  "name"?: string,
  "mid"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "sendDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "rid"?:string,
  "status"?:string,
  "orderId"?:string,
  "transactionType"?:string,
  "dateFrom"?:string,
  "dateTo"?:string,
  "customerMobile"?:string,
  "totalAmount"?:string
  "Status"?:string,
  "user_type"?:string,

  "customerName"?:string,
  "customerId"?:string,
  "currency"?:string,
  "amount"?:any,
  "merchantName"?:string,
  "merchant"?:string,
  "merchantId"?:string
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}

@Component({
  selector: 'app-merchant-transaction-report',
  templateUrl: './merchant-transaction-report.component.html',
  styleUrls: ['./merchant-transaction-report.component.scss']
})
export class MerchantTransactionReportComponent implements OnInit {

  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();

  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public pageNumber :any = 0;
  public searchMerName:string;
  public searchMID: string ;
  public resellerPartnerId:string;
  public Status:string;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public searchFromDateTime: string;
  public searchToDateTime: string;
  public selectedMerchant: string;
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  user_type:'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean= true;
  private gridApi!: GridApi;
   public rowData!: any[];
   collectiondata: number=0;
   collectionSize: number = 0;
   currentPage: number = 1;
   public permissions: any = '';
   Resultdata: any;
   resellerListOptions: any;
   merchantStatusdata: any;
   private gridColumnApi!: ColumnApi;
   currentDate:any=new Date();
   private filterObj: any = {};
   globalSearch: string = '';
   private innerWidth: number;
   modalConfigAdd: ModalConfig;
   modalConfigEdit: ModalConfig;
   modalConfigMerchant: ModalConfig;
   modalConfigReport: ModalConfig;
   image : any;
   mindatadis: boolean = true;
   loading: boolean = false;
   isMerchantReport : boolean = false;
   customerMobile :any;
   transactionType : any;
   status :any;
   orderId : any;
   dateFrom :NgbDateStruct;
   dateTo : NgbDateStruct;
   minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  sort : any = "DESC";
  columnName : any = "createDate";

  customerEmail: string = '';
  customerPhone: string = '';
  currency: any;
  paymentMethod: string = 'ALL';
  mopType: string = 'ALL';
  statusList: any = [];
  customerData:any=[];
  merchant:any;
  pOrderId: string = '';
  customerName:string='';
  customerId:any;
  amount:any;
  txnStatus:string='';
  merchantId:string='';
  merchantName:string='';

  columnnName:string="";
  logicalCondition:any;
  searchText:any;
  columnnName1:string="";
  logicalCondition1:any;
  searchText1:any;
  columnnName2:string="";
  logicalCondition2:any;
  searchText2:any;
   public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 180,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filTransactionType') private filTransactionType: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  public columnDefs: ColDef[] = [
    // { field: 'receiverName', sortable: false, lockVisible: true, headerName: 'Merchant', resizable: true },
    { field: 'receiverId', sortable: false, lockVisible: true, headerName: 'Merchant UUID' },
    { field: 'merchantIdentifierId', sortable: false, lockVisible: true, headerName: 'Merchant ID' },
    // { field: 'resellerId', sortable: false, lockVisible: true, headerName: 'Reseller ID' },
    { field: 'receiverName', sortable: false, lockVisible: true, headerName: 'Receiver Name' },
    { field: 'userId', sortable: false, lockVisible: true, headerName: 'Customer ID' },
    { field: 'sender', sortable: false, lockVisible: true, headerName: 'Sender Name' },
    { field: 'userMobile', sortable: false, lockVisible: true, headerName: 'Customer Mobile' },
    { field: 'txnId', sortable: false, lockVisible: true, headerName: 'Transaction ID' },
    { field: 'transactionType', sortable: false, lockVisible: true, headerName: 'Credit / Debit' },
    // { field: 'merchantReferenceId', sortable: false, lockVisible: true, headerName: 'Order ID' },
    // { field: 'senderVAIBAN', sortable: false, lockVisible: true, headerName: 'Sender VA IBAN',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    // { field: 'receiverVAIBAN', sortable: false, lockVisible: true, headerName: 'Receiver VA IBAN',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    // { field: 'resellerId', sortable: false, lockVisible: true, headerName: 'Parent ID' },
    { field: 'currency', sortable: false, lockVisible: true, headerName: 'Currency' },
    {
      field: 'amount', sortable: false, lockVisible: true, headerName: 'Sale Amount', valueFormatter: (params) => {
        return params.value != null ? Number(params.value).toFixed(2) : '';
      }
    },
    { field: 'serviceCharges', sortable: false, lockVisible: true, headerName: 'Fee Amount' },
    { field: 'vatOnCommission', sortable: false, lockVisible: true, headerName: 'VAT of Fee' },
    { field: 'receivingAmount', sortable: false, lockVisible: true, headerName: 'Net Amount' },
    { field: 'status', sortable: false, lockVisible: true, headerName: 'Status' },
    // { field: 'responseMessage', sortable: false, lockVisible: true, headerName: 'Shield Message' },
    // { field: 'responseCode', sortable: false, lockVisible: true, headerName: 'Shield Status' },
  //  { field: '', sortable: false, lockVisible: true, headerName: 'Shield Message' },
    // { field: 'serviceProviderResponseCode', sortable: false, lockVisible: true, headerName: 'SP Status' },
    // { field: 'serviceProviderResponseMessage', sortable: false, lockVisible: true, headerName: 'SP Message' },
    // { field: 'serviceProviderTxnId', sortable: false, lockVisible: true, headerName: 'SP Trxn ID' },
    { field: 'dateTime', sortable: false, lockVisible: true, headerName: 'Trxn Initiated Date Time' },
    { field: 'updateDateTime', sortable: false, lockVisible: true, headerName: 'Updated Trxn Date Time' },
    { field: 'stan', sortable: false, lockVisible: true, headerName: 'Stan' },
    { field: 'ipAddress', sortable: false, lockVisible: true, headerName: 'IP Address'},
    { field: 'gps', sortable: false, lockVisible: true, headerName: 'GPS Coordinates' },
    { field: 'osType', sortable: false, lockVisible: true, headerName: 'OS Type' },
    { field: 'osVersion', sortable: false, lockVisible: true, headerName: 'OS Version' },
    { field: 'deviceModel', sortable: false, lockVisible: true, headerName: 'Device Model' },
    { field: 'deviceId', sortable: false, lockVisible: true, headerName: 'Device ID' },
    { field: 'originalTxnId',  headerName: 'Original TRXN ID',lockVisible:true, },
    { field: 'appVersion', sortable: false, lockVisible: true, headerName: 'App Version' },
    { field: 'typeOfTransaction', sortable: false, lockVisible: true, headerName: 'Txn Type' },
    { field: 'productCode', sortable: false, lockVisible: true, headerName: 'Product Code' },
    { field: 'channel', sortable: false, lockVisible: true, headerName: 'Channel' },
    { field: 'category', sortable: false, lockVisible: true, headerName: 'Category' },
    { field: 'initiatedFrom', sortable: false, lockVisible: true, headerName: 'Mode' },
    { field: 'referenceId', sortable: false, lockVisible: true, headerName: 'Pay10 Reference ID'},
    { field: 'splitPayment', sortable: false, lockVisible: true, headerName: 'Split Payment' },
    { field: 'instantCapture', sortable: false, lockVisible: true, headerName: 'Instant Captured' },
    { field: '', sortable: false, lockVisible: true, headerName: 'Outlet ID' },
    { field: 'merchantTerminalId', sortable: false, lockVisible: true, headerName: 'Terminal ID' },
    { field: 'commissionPercentage', sortable: false, lockVisible: true, headerName: 'Commission' },
    { field: 'rrn', sortable: false, lockVisible: true, headerName: 'Bank Reference/RRN' },
    // { field: 'vamReferenceNumber', sortable: false, lockVisible: true, headerName: 'Vam Reference' },
    {
      field: 'unmasking',
      headerName: 'Unmasking',
      lockVisible: true,
      width: 120,
      cellRenderer: BtnCellRenderer1,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            // Toggle PII unmask for the entire row
            this.piiGridService.unmaskRow(param.data, this.gridApi);
          },
          buttonIconClass: 'icon-frame-1',
          buttonText: '',
          buttonVisible: true,
          customImage: 'assets/images/unmask-icon.png'
        }
      ]
    }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(private menuService: MenusService,private location : Location,private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService,
    private ngbCalender: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter,private transactionService : TransactionMasterService,private customerService : CustomerService, private piiGridService: PiiGridService, private exportTrackingService: ExportTrackingService) {

    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
  }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    // this.searchFromDate= this.ngbCalender.getToday();
    // this.searchToDate= this.ngbCalender.getToday();
    this.merchnatList();
    this.customerList();
    this.currencyList();
  }

  merchnatList() {
    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.merchantService.getMerchantList("","","","","","","",filter,"ALL",0).subscribe((response)=>{
      console.log(response);
      this.Resultdata = response.content;
    })
  }
  customerList() {
    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.customerService.getCustomerDropDown().subscribe((response:any)=>{
      console.log(response);
     this.customerData = response.content;
    })
  }

  currencyrData:any=[];
  currencyList() {
    this.customerService.getCurrencyList().subscribe((response:any)=>{
      console.log(response);
     this.currencyrData = response.response.data;
     console.log(this.currencyrData);
     this.currencyrData  = [...new Set(this.currencyrData.map((item:any) => item.currencyCode))];
     console.log(this.currencyrData);
    })
  }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }

  merchantStatusDropdown() {
    return this.merchantService.getMerchantStatus()
        // .post(
        //   `${API_URL}/GetDropdown`, postdata
        // )
        .subscribe((res) => (this.merchantStatusdata = res,console.log("res",this.merchantStatusdata)));

    }

  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  OnlyNumbersAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58);
  }

  onExportCSV() {
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Merchant_Transaction_Report' + "_" + referenceId;

       this.onSearchPayments();

        // Create export data with proper field mapping
        const expData: any[] = [];
        if (this.rowData && this.rowData.length > 0) {
          this.rowData.forEach((curr: any) => {
            const tempRec: any = {};

            // Get only non-action columns (include empty field columns for headers)
            const exportColumns = this.tableSelectedColumn.filter(col => col.field !== 'actions' && col.field !== 'unmasking');

            exportColumns.forEach((col) => {
              if (col.field && col.field !== '') {
                // Handle nested or complex field mappings
                tempRec[col.headerName || col.field] = this.getFieldValue(curr, col.field);
              } else {
                // For columns with empty fields, add empty value but keep the header
                tempRec[col.headerName || 'Unknown'] = '';
              }
            });

            expData.push(tempRec);
          });

          this.exportAsExcelFile(expData, fileName);
        } else {
          this.alertService.errorAlertWithMessage("No data available to export");
        }
  }

  // Helper method to safely get field values
  private getFieldValue(data: any, fieldPath: string): any {
    if (!fieldPath) return '';

    try {
      // Handle nested field paths (e.g., 'user.profile.name')
      const value = fieldPath.split('.').reduce((obj, key) => obj?.[key], data);
      return value !== null && value !== undefined ? value : '';
    } catch (error) {
      console.warn(`Error accessing field ${fieldPath}:`, error);
      return '';
    }
  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'MERCHANT_TRANSACTION_REPORT',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Merchant transaction export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
    try {
      // Get exportable columns (exclude only actions and unmasking columns)
      const exportableColumns = this.tableSelectedColumn.filter(col =>
        col.field !== 'actions' &&
        col.field !== 'unmasking'
      );

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();

      // Method 1: Using json_to_sheet for better data integrity
      if (json.length > 0) {
        // Ensure consistent column order by creating ordered data
        const orderedData = json.map(row => {
          const orderedRow: any = {};
          exportableColumns.forEach(col => {
            const headerName = col.headerName || col.field;
            // Use either the headerName as key or the field name
            orderedRow[headerName as string] = row[headerName as string] || (col.field ? row[col.field] : '') || '';
          });
          return orderedRow;
        });

        // Create worksheet from ordered data
        const worksheet = XLSX.utils.json_to_sheet(orderedData);

        // Set column widths
        const columnWidths = exportableColumns.map(col => ({
          wch: Math.max(15, (col.headerName || col.field || '').length + 5)
        }));
        worksheet['!cols'] = columnWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Transaction Report');
      } else {
        // Create empty worksheet with headers only
        const headers = exportableColumns.map(col => col.headerName || col.field);
        const worksheet = XLSX.utils.aoa_to_sheet([headers]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Transaction Report');
      }

      // Generate Excel file and save
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
        compression: true
      });

      this.saveAsExcelFile(excelBuffer, excelFileName);

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      this.alertService.errorAlertWithMessage('Failed to export data to Excel. Please try again.');
    }
  }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      merchantName: this.searchMerName || '',
      merchantId: this.searchMID || '',
      status: this.Status || '',
      transactionType: this.filTransactionType || '',
      dateFrom: this.searchFromDateTime ? this.searchFromDateTime.replace('T', ' ') : '',
      dateTo: this.searchToDateTime ? this.searchToDateTime.replace('T', ' ') : '',
      orderId: this.orderId || '',
      resellerPartnerId: this.resellerPartnerId || '',
      customerMobile: this.customerMobile || '',
      customerId: this.customerId || '',
      amount: this.amount || ''
    };
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    try {
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      const timestamp = new Date().getTime();
      FileSaver.saveAs(data, `${fileName}_${timestamp}${EXCEL_EXTENSION}`);

      this.alertService.successAlert(
         "Export Successful"
    );
    } catch (error) {
      console.error('Error saving Excel file:', error);
      this.alertService.errorAlertWithMessage('Failed to save Excel file. Please try again.');
    }
  }

  onSearchFilter(){
    this.pageNumber = 0;
    this.onSearchPayments();
  }

 onSearchPayments(){
    const filter: merchantFilter = {}

      // Validation for Column Name 1
  if (this.columnnName && !this.logicalCondition) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 1
  if (this.logicalCondition && !this.searchText) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 2
  if (this.columnnName1 && !this.logicalCondition1) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 2
  if (this.logicalCondition1 && !this.searchText1) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 3
  if (this.columnnName2 && !this.logicalCondition2) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 3
  if (this.logicalCondition2 && !this.searchText2) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }
   // console.log("Date From : "+this.dateFrom+"00:00:00");
 // console.log("Date To : "+this.dateTo+"59:59:59");


    // console.log("new");

    console.log("Customer Name:", this.customerName);
    // console.log("Customer Mobile :"+this.customerMobile);
    console.log("Customer ID:", this.customerId);
    console.log("Currency:", this.currency);
    console.log("Amount:", this.amount);
    console.log("Merchant Name:", this.merchantName);
    console.log("Merchant:", this.merchant);
    console.log("Merchant ID:", this.merchantId);

    if(this.customerMobile != undefined){
      filter.customerMobile = this.customerMobile;
    }
    else{
      filter.customerMobile = "";
    }

    if(this.transactionType != undefined){
      console.log("Data ");
      filter.transactionType = this.transactionType;
    }else{
      filter.transactionType = "ALL";
    }

    if(this.status != undefined){
      filter.status = this.status;
    }else{
      filter.status = "ALL";
    }

    if(this.orderId != undefined){
      filter.orderId = this.orderId;
    }

    if(this.searchFromDateTime){
      filter.dateFrom = this.searchFromDateTime.replace('T', ' ') + ':00';
    }else{
      filter.dateFrom = "";
    }

    if(this.searchToDateTime){
      filter.dateTo = this.searchToDateTime.replace('T', ' ') + ':00';
    }else{
      filter.dateTo = "";
    }

    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }

    filter.customerName = this.customerName ?? "";
    filter.customerId = this.customerId ?? "";
    filter.currency = this.currency ?? "";
    filter.amount = this.amount ?? "";
    filter.merchantName = this.merchantName ?? "";
    filter.merchant = this.merchant ?? "";
    filter.merchantId = this.merchantId ?? "";

    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }
    return this.transactionService.getMerchantTransactionReport(filter,this.customerMobile,this.transactionType,this.status,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
    .subscribe((res:any) => {
      console.log(res);

      if(res.response.data.content.length<=0){
        console.log("No data");
        this.alertService.errorAlertWithMessage("No records present");
      }
      const currentDate = new Date();
      const cValue = formatDate(currentDate, 'yyyy-MM-dd', 'en-US');
      console.log(cValue);
      this.rowData = res.response.data.content;
      this.rowData.map((_: any) => {
        _.splitPayment = 'N';
        if(_.longitude != null && _.latitude != null ){
          _.gps =  _.longitude+" , "+_.latitude;
        }else{
          _.gps = '';
        }
     })
      this.collectiondata = res.response.data.content
      this.collectionSize= res.response.data.totalElements
      this.totalRecords =  res.response.data.totalElements
    })
  }

  onBackgroundExport() {
    const filter: merchantFilter = {}

      // Validation for Column Name 1
  if (this.columnnName && !this.logicalCondition) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 1
  if (this.logicalCondition && !this.searchText) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 2
  if (this.columnnName1 && !this.logicalCondition1) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 2
  if (this.logicalCondition1 && !this.searchText1) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 3
  if (this.columnnName2 && !this.logicalCondition2) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 3
  if (this.logicalCondition2 && !this.searchText2) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }
   // console.log("Date From : "+this.dateFrom+"00:00:00");
 // console.log("Date To : "+this.dateTo+"59:59:59");


    // console.log("new");

    console.log("Customer Name:", this.customerName);
    // console.log("Customer Mobile :"+this.customerMobile);
    console.log("Customer ID:", this.customerId);
    console.log("Currency:", this.currency);
    console.log("Amount:", this.amount);
    console.log("Merchant Name:", this.merchantName);
    console.log("Merchant:", this.merchant);
    console.log("Merchant ID:", this.merchantId);
    console.log("Search From Date:", this.searchFromDate);
    console.log("Search To Date:", this.searchToDate);
    console.log("Column Name:", this.columnnName);
    console.log("Logical Condition:", this.logicalCondition);
    console.log("Search Text:", this.searchText);
    console.log("Column Name 1:", this.columnnName1);
    console.log("Logical Condition 1:", this.logicalCondition1);
    console.log("Search Text 1:", this.searchText1);
    console.log("Column Name 2:", this.columnnName2);
    console.log("Logical Condition 2:", this.logicalCondition2);
    console.log("Search Text 2:", this.searchText2);

    if(this.customerMobile != undefined){
      filter.customerMobile = this.customerMobile;
    }
    else{
      filter.customerMobile = "";
    }

    if(this.transactionType != undefined){
      console.log("Data ");
      filter.transactionType = this.transactionType;
    }else{
      filter.transactionType = "ALL";
    }

    if(this.status != undefined){
      filter.status = this.status;
    }else{
      filter.status = "ALL";
    }

    if(this.orderId != undefined){
      filter.orderId = this.orderId;
    }

    if(this.searchFromDateTime){
      filter.dateFrom = this.searchFromDateTime.replace('T', ' ') + ':00';
    }else{
      filter.dateFrom = "";
    }

    if(this.searchToDateTime){
      filter.dateTo = this.searchToDateTime.replace('T', ' ') + ':00';
    }else{
      filter.dateTo = "";
    }

    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }

    filter.customerName = this.customerName ?? "";
    filter.customerId = this.customerId ?? "";
    filter.currency = this.currency ?? "";
    filter.amount = this.amount ?? "";
    filter.merchantName = this.merchantName ?? "";
    filter.merchant = this.merchant ?? "";
    filter.merchantId = this.merchantId ?? "";

    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }

    this.transactionService.getTransactionReportBackgroundExport(
      filter,this.customerMobile,this.transactionType,this.status,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3,true
    )
    .subscribe(
      (response: any) => {
        this.loading = false;
        console.log('Background export response:', response);

        if (response?.response?.status === 200) {
          const referenceId = response.response.data[" document referenceId"] || response.response.data.documentReferenceId;
          const recordsCount = response.response.data.recordsCount;

          this.alertService.successAlertWithAcknowledgment(
            `Your export of ${recordsCount} records has started. Reference ID: ${referenceId}`
          );
        } else if (response?.response?.status === 509) {
          this.alertService.errorAlertWithMessage(
            `Export limit exceeded: ${response.response.data.message}`
          );
        } else {
          this.alertService.errorAlertWithMessage(
            response?.response?.message || "An error occurred during export. Please try again later."
          );
        }
      },
      error => {
        this.loading = false;
        console.error('Background export error:', error);

        this.alertService.errorAlertWithMessage(
          error?.response?.message || "Failed to start background export. Please try again later."
        );
      }
    );
  }

  onSearchBtnClick($event: Event) {
    const filter: merchantFilter = {}
    debugger
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else{
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
     if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType

      if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    // if (this.Status) filter.Status=this.Status||'';
    if(this.searchFromDateTime){
      filter.startDate = this.searchFromDateTime.replace('T', ' ') + ':00';
    }else{
      filter.startDate = "";
    }
    if(this.searchToDateTime){
      filter.endDate = this.searchToDateTime.replace('T', ' ') + ':00';
    }else{
      filter.endDate = "";
    }
    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.searchFromDate);
    console.log(this.searchToDate);
    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }

    return this.transactionService.getMerchantTransactionReport(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.splitPayment = 'N';
          if(_.longitude != null && _.latitude != null ){
            _.gps =  _.longitude+" , "+_.latitude;
          }else{
            _.gps = '';
          }
       })
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
        if(data.response.data.content.length<=0){
          console.log("No data");
          this.alertService.errorAlertWithMessage("No records present");
          return }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked" + param.data.registeredMobile);
    // return await this.router.navigate(['/customerEdit'], {

    //   queryParams: {
    //     mid: param?.data?.registeredMobile,
    //   }
    // })

  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    console.log(param);
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    this.pageNumber = (param -1);
    this.onSearchPayments();
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    this.pageNumber = 0;
    this.onSearchPayments();

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    const filter: merchantFilter = {}
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    const currentDate = new Date();
    const cValue = formatDate(currentDate, 'yyyy-MM-dd', 'en-US');
    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);

    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }
    return this.transactionService.getMerchantTransactionReport(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.splitPayment = 'N';
          if(_.longitude != null && _.latitude != null ){
            _.gps =  _.longitude+" , "+_.latitude;
          }else{
            _.gps = '';
          }
       })
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
      });
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {

      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event : any){
    const filter: merchantFilter = {}
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
    if(listOfSortModel != null){
      if(listOfSortModel.length != 0){
        if(listOfSortModel[0].sort == "asc"){
          this.sort = "ASC";
        }else{
          this.sort = "DESC";
        }

        console.log(listOfSortModel[0].colId);
        this.columnName = listOfSortModel[0].colId;
        if(this.customerMobile == undefined){
          this.customerMobile = "";
        }
        if(this.transactionType == undefined){
          this.transactionType = null;
        }
        if(this.status == undefined){
          this.status = null;
        }

    if(this.searchFromDateTime){
      filter.dateFrom = this.searchFromDateTime.replace('T', ' ') + ':00';
    }else{
      filter.dateFrom = "";
    }

    if(this.searchToDateTime){
      filter.dateTo = this.searchToDateTime.replace('T', ' ') + ':00';
    }else{
      filter.dateTo = "";
    }

        let column1:any={
          columnnName:this.columnnName ?? "",
          logicalCondition:this.logicalCondition ?? "",
          searchText:this.searchText ?? "",
        }
        let column2:any={
          columnnName:this.columnnName1 ?? "",
          logicalCondition:this.logicalCondition1 ?? "",
          searchText:this.searchText1 ?? "",
        }
        let column3:any={
          columnnName:this.columnnName2 ?? "",
          logicalCondition:this.logicalCondition2 ?? "",
          searchText:this.searchText2 ?? "",
        }

        this.transactionService.getMerchantTransactionReport(filter,this.customerMobile,this.transactionType,this.status,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
          .subscribe((data:any) => {
            console.log(data);
            this.rowData = data.response.data.content;
            this.rowData.map((_: any) => {
              _.splitPayment = 'N';
              if(_.longitude != null && _.latitude != null ){
                _.gps =  _.longitude+" , "+_.latitude;
              }else{
                _.gps = '';
              }
           })
            this.collectiondata = data.response.data.content
            this.collectionSize= data.response.data.totalElements
            this.totalRecords =  data.response.data.totalElements
          });

      }else{
        this.columnName = "";
        this.sort = "";
        if(this.customerMobile == undefined){
          this.customerMobile = "";
        }
        if(this.transactionType == undefined){
          this.transactionType = null;
        }
        if(this.status == undefined){
          this.status = null;
        }
        let column1:any={
          columnnName:this.columnnName ?? "",
          logicalCondition:this.logicalCondition ?? "",
          searchText:this.searchText ?? "",
        }
        let column2:any={
          columnnName:this.columnnName1 ?? "",
          logicalCondition:this.logicalCondition1 ?? "",
          searchText:this.searchText1 ?? "",
        }
        let column3:any={
          columnnName:this.columnnName2 ?? "",
          logicalCondition:this.logicalCondition2 ?? "",
          searchText:this.searchText2 ?? "",
        }
        this.transactionService.getMerchantTransactionReport(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
          .subscribe((data:any) => {
            console.log(data);
            this.rowData = data.response.data.content;
            this.rowData.map((_: any) => {
              _.splitPayment = 'N';
              if(_.longitude != null && _.latitude != null ){
                _.gps =  _.longitude+" , "+_.latitude;
              }else{
                _.gps = '';
              }
           })
            this.collectiondata = data.response.data.content
            this.collectionSize= data.response.data.totalElements
            this.totalRecords =  data.response.data.totalElements
          });
      }
    }
  }
  allowAlfanumeric($event: Event): void {
    if(this.searchMID.length>10)
    {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.searchFromDate);
    console.log(this.searchToDate);
    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }
    return this.transactionService.getMerchantTransactionReport(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.splitPayment = 'N';
          if(_.longitude != null && _.latitude != null ){
            _.gps =  _.longitude+" , "+_.latitude;
          }else{
            _.gps = '';
          }
       })
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
      });

  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  resetFilter() {
    this.searchFromDate = { year: 0, month: 0, day: 0 };
    this.searchToDate = { year: 0, month: 0, day: 0 };
    this.customerName = "";
    this.customerMobile = "";
    this.customerId = null;
    this.amount = "";

    this.currency = null;
    this.status = null;
    this.merchantName = "";
    this.merchant = null;
    this.merchantId = "";
    this.columnnName = "";
    this.logicalCondition = "";
    this.searchText = "";
    this.columnnName1 = "";
    this.logicalCondition1 = "";
    this.searchText1 = "";
    this.columnnName2 = "";
    this.logicalCondition2 = "";
    this.searchText2 = "";

    // Clear any additional form-specific handlers
    if (this.filStatus) this.filStatus.handleClearClick();
    if (this.filTransactionType) this.filTransactionType.handleClearClick();
    if (this.filResellerPartnerId) this.filResellerPartnerId.handleClearClick();
    this.onSearchPayments();
}

  onColumnNameChange() {
    if (!this.columnnName) {
      this.logicalCondition = '';
      this.searchText = '';
    }
  }

  onColumnNameChange1() {
    if (!this.columnnName1) {
      this.logicalCondition1 = '';
      this.searchText1 = '';
    }
  }

  onColumnNameChange2() {
    if (!this.columnnName2) {
      this.logicalCondition2 = '';
      this.searchText2 = '';
    }
  }
  getDisabledColumns(): string[] {
    return [this.columnnName, this.columnnName1, this.columnnName2];
  }
}
